// Components
import Password from "./Password";

export default function ContentPassword() {
    return <Password></Password>;
}